import React, { useState } from "react";

const TreatmentModal = ({ isOpen, onClose, onSave, parents = [] }) => {
  const [selectedParents, setSelectedParents] = useState([]);
  const [billingParents, setBillingParents] = useState([]);

  const handleSave = () => {
    onSave(selectedParents || [], billingParents || []);
    onClose();
  };

  const handleSkip = () => {
    onSave([], []); // Pass empty arrays
    onClose();
  };

  return isOpen ? (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
      <div className="bg-white rounded-sm shadow-lg w-full max-w-3xl p-6">
        {/* Modal Header */}
        <div className="flex justify-between items-center border-b pb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            Attendance and Split Billing
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600">
            ✕
          </button>
        </div>

        {/* Attendance & Split Billing Controls */}
        <div className="mt-6 grid grid-cols-2 gap-4">
          {/* Attendance Checkbox Group */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">
              Select Attendance
            </h3>
            <div className="border rounded-sm p-3 bg-gray-50">
              {parents && parents.length > 0 ? (
                parents.map((parent) => (
                  <label
                    key={parent._id}
                    className="flex items-center space-x-2 mb-1">
                    <input
                      type="checkbox"
                      checked={selectedParents.includes(parent)}
                      onChange={() =>
                        setSelectedParents((prev) =>
                          prev.includes(parent)
                            ? prev.filter((p) => p !== parent)
                            : [...prev, parent]
                        )
                      }
                      className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                    />
                    <span className="text-sm text-gray-900">
                      {parent.firstName} {parent.lastName}
                    </span>
                  </label>
                ))
              ) : (
                <div className="text-sm text-gray-900">No parents found</div>
              )}
            </div>
          </div>

          {/* Split Billing Checkbox Group */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">
              Select Split Billing
            </h3>
            <div className="border rounded-sm p-3 bg-gray-50">
              {parents && parents.length > 0 ? (
                parents.map((parent) => (
                  <label
                    key={parent._id}
                    className="flex items-center space-x-2 mb-1">
                    <input
                      type="checkbox"
                      checked={billingParents.includes(parent)}
                      onChange={() =>
                        setBillingParents((prev) =>
                          prev.includes(parent)
                            ? prev.filter((p) => p !== parent)
                            : [...prev, parent]
                        )
                      }
                      disabled={!selectedParents.includes(parent)}
                      className={`h-4 w-4 ${
                        selectedParents.includes(parent)
                          ? "text-indigo-600 border-gray-300 focus:ring-indigo-500"
                          : "cursor-not-allowed opacity-50"
                      } rounded`}
                    />
                    <span
                      className={`text-sm ${
                        selectedParents.includes(parent)
                          ? "text-gray-900"
                          : "text-gray-400"
                      }`}>
                      {parent.firstName} {parent.lastName}
                    </span>
                  </label>
                ))
              ) : (
                <div className="text-sm text-gray-900">No parents found</div>
              )}
            </div>
          </div>
        </div>

        {/* Summary Section */}
        <div className="mt-6">
          <h3 className="text-base font-semibold text-gray-900">Summary</h3>
          <p className="mt-2 text-sm text-gray-700">
            <strong>Attendance:</strong>{" "}
            {selectedParents.length > 0
              ? selectedParents
                  .map((p) => `${p.firstName} ${p.lastName}`)
                  .join(", ")
              : "None"}
          </p>
          <p className="mt-1 text-sm text-gray-700">
            <strong>Split Billing With:</strong>{" "}
            {billingParents.length > 0
              ? billingParents
                  .map((p) => `${p.firstName} ${p.lastName}`)
                  .join(", ")
              : "None"}
          </p>
        </div>

        {/* Modal Actions */}
        <div className="flex justify-end space-x-2 mt-6">
          <button
            className="px-3 py-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-sm hover:bg-gray-300"
            onClick={onClose}>
            Cancel
          </button>

          {parents.length === 0 ? (
            <button
              className="px-4 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-sm hover:bg-indigo-500"
              onClick={handleSkip}>
              Skip
            </button>
          ) : (
            <>
              <button
                className="px-3 py-2 text-sm font-semibold text-gray-500 bg-gray-100 rounded-sm hover:bg-gray-200"
                onClick={handleSkip}>
                Skip
              </button>
              <button
                className="px-3 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-sm hover:bg-indigo-500"
                onClick={handleSave}>
                Save
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default TreatmentModal;
